/* Fuse.js powered search modal */
(function () {
    var modal = document.getElementById('fuse-search');
    if (!modal) return;

    var container = modal.querySelector('.fuse-search-container');
    var input = modal.querySelector('#fuse-search-input');
    var resultsEl = modal.querySelector('#fuse-search-results');
    var statusEl = modal.querySelector('#fuse-search-status');
    var closeBtn = modal.querySelector('.fuse-search-close');
    var backdrop = modal.querySelector('.fuse-search-backdrop');

    var apiKey = container.dataset.apiKey;
    var siteUrl = (container.dataset.siteUrl || '').replace(/\/$/, '');

    var fuseIndex = null;
    var selectedIndex = -1;
    var currentResults = [];
    var debounceTimer = null;
    var loadingPromise = null;

    /* ---- open / close ---- */

    function openSearch() {
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflowY = 'hidden';
        modal.classList.add('is-backdrop-ready');
        requestAnimationFrame(function () {
            modal.classList.add('is-open');
            input.focus();
        });
        if (!fuseIndex && !loadingPromise) loadPosts();
    }

    function closeSearch() {
        modal.classList.remove('is-open', 'is-backdrop-ready');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflowY = '';
        input.value = '';
        resultsEl.innerHTML = '';
        statusEl.textContent = '';
        selectedIndex = -1;
        currentResults = [];
    }

    /* ---- wire up all search triggers ---- */

    document.querySelectorAll('.gh-search, [data-ghost-search]').forEach(function (btn) {
        btn.removeAttribute('data-ghost-search');
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            openSearch();
        });
    });

    closeBtn.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            closeSearch();
            return;
        }
        if (!modal.classList.contains('is-open')) return;

        var items = resultsEl.querySelectorAll('.fuse-search-result');
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
            updateSelection(items);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            selectedIndex = Math.max(selectedIndex - 1, -1);
            updateSelection(items);
        } else if (e.key === 'Enter' && selectedIndex >= 0 && items[selectedIndex]) {
            window.location.href = items[selectedIndex].href;
        }
    });

    function updateSelection(items) {
        items.forEach(function (item, i) {
            item.classList.toggle('is-selected', i === selectedIndex);
        });
    }

    /* ---- data fetching ---- */

    function loadPosts() {
        var cached = null;
        try { cached = sessionStorage.getItem('fuse_posts_v1'); } catch (e) {}

        if (cached) {
            try {
                buildIndex(JSON.parse(cached));
                return;
            } catch (e) {}
        }

        if (!apiKey) {
            statusEl.textContent = 'Search not configured — add your Content API key in Ghost Admin → Design.';
            return;
        }

        statusEl.textContent = 'Loading search index\u2026';

        loadingPromise = fetchAllPosts()
            .then(function (posts) {
                try { sessionStorage.setItem('fuse_posts_v1', JSON.stringify(posts)); } catch (e) {}
                buildIndex(posts);
                statusEl.textContent = '';
                var q = input.value.trim();
                if (q.length >= 2) doSearch(q);
            })
            .catch(function () {
                statusEl.textContent = 'Search unavailable — please try again later.';
                loadingPromise = null;
            });
    }

    function fetchAllPosts() {
        var fields = 'id,title,slug,excerpt,custom_excerpt,plaintext,url,published_at';
        var include = 'tags';
        var baseParams = '?key=' + encodeURIComponent(apiKey) +
            '&fields=' + fields +
            '&include=' + include +
            '&limit=100' +
            '&order=published_at%20desc';

        var allPosts = [];

        function fetchPage(page) {
            var url = siteUrl + '/ghost/api/content/posts/' + baseParams +
                (page > 1 ? '&page=' + page : '');

            return fetch(url)
                .then(function (res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.json();
                })
                .then(function (data) {
                    allPosts = allPosts.concat(data.posts || []);
                    var pagination = data.meta && data.meta.pagination;
                    if (pagination && pagination.next) {
                        return fetchPage(pagination.next);
                    }
                    return allPosts;
                });
        }

        return fetchPage(1);
    }

    function buildIndex(posts) {
        fuseIndex = new Fuse(posts, {
            includeScore: true,
            threshold: 0.1,
            minMatchCharLength: 2,
            ignoreLocation: true,
            keys: [
                { name: 'title',          weight: 10 },
                { name: 'tags.name',      weight: 5  },
                { name: 'custom_excerpt', weight: 3  },
                { name: 'excerpt',        weight: 2  },
                { name: 'plaintext',      weight: 1  }
            ]
        });
    }

    /* ---- search input ---- */

    input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            var q = input.value.trim();
            if (q.length < 2) {
                resultsEl.innerHTML = '';
                statusEl.textContent = '';
                currentResults = [];
                selectedIndex = -1;
                return;
            }
            if (!fuseIndex) {
                if (!loadingPromise) loadPosts();
                return;
            }
            doSearch(q);
        }, 150);
    });

    function doSearch(q) {
        currentResults = fuseIndex.search(q, { limit: 100 });
        selectedIndex = -1;
        renderResults(currentResults);
    }

    /* ---- rendering ---- */

    function renderResults(results) {
        if (!results.length) {
            resultsEl.innerHTML = '';
            statusEl.textContent = 'No results found.';
            return;
        }
        statusEl.textContent = '';
        resultsEl.innerHTML = results.map(function (r) {
            var post = r.item;
            var tags = (post.tags || []).slice(0, 3).map(function (t) {
                return '<span class="fuse-search-result-tag">' + esc(t.name) + '</span>';
            }).join('');
            var excerpt = post.custom_excerpt || post.excerpt || '';
            if (excerpt.length > 110) excerpt = excerpt.slice(0, 110) + '\u2026';

            return '<a class="fuse-search-result" href="' + esc(post.url) + '">' +
                '<div class="fuse-search-result-title">' + esc(post.title) + '</div>' +
                (excerpt ? '<div class="fuse-search-result-excerpt">' + esc(excerpt) + '</div>' : '') +
                '<div class="fuse-search-result-meta">' +
                (post.published_at ? '<span>' + formatDate(post.published_at) + '</span>' : '') +
                tags +
                '</div>' +
                '</a>';
        }).join('');
    }

    function formatDate(str) {
        try {
            return new Date(str).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        } catch (e) { return ''; }
    }

    function esc(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }
})();
